/* eslint-disable quotes */
import { useState } from 'react';

import { useStore } from '../../../core/utils/hook';
import '../style.scss';
import DragDropFileMulti from '../../../components/DragDropFile/DragDropFileMulti';
import { SHARE_KNOWLEDGE_FILE_TYPE } from '../../../core/configs/constants';
import { formatBytes } from '../../../core/utils/common';
import { IconUploadForm } from './Icon';

const getFileExtension = (fileName) => {
    const parts = fileName.split('.');
    return parts.length > 1 ? parts.pop().toLowerCase() : '';
};

const getFileName = (fileName) => {
    const parts = fileName.split('.');
    return parts.length > 1 ? parts[0] : '';
};

const DOCUMENT_MAX_SIZE = 100 * 1024 * 1024; // 100MB
const ModalUploadDocument = (props) => {
    // store
    const {
        modalStore: { hide, show },
        fileStore: { uploadFile },
        userStore: { userInfoHeader },
        shareKnowledgeStore: { createFile, getPresignedUrls }
    } = useStore();
    const [docList, setDocList] = useState([]);

    const handleUploadFile = async (fileUploadList, uploadSuccessCallback) => {
        try {
            for (const fileUpload of fileUploadList) {
                const fields = fileUpload?.fields;
                const { bucket, ...payload } = fields;
                const data = {
                    ...(payload || {}),
                    file: fileUpload.file
                };

                await new Promise((resolve, reject) => {
                    uploadFile(fileUpload.presignedUrl, data, {
                        onSuccess: () => {
                            resolve(true);
                        },
                        onError: () => {
                            reject(new Error('Upload failed'));
                        },
                        onUploadProgress: (progress) => {}
                    });
                });
            }

            uploadSuccessCallback();
        } catch (error) {
            console.error('Error during file upload:', error);
        }
    };

    const onChangeFile = (files) => {
        const existingNames = docList.map((item) => item.file.name);

        const newFiles = files
            .filter((file) => !existingNames.includes(file.name))
            .map((file) => {
                return {
                    file,
                    isErr: file.size > DOCUMENT_MAX_SIZE
                };
            });

        setDocList((prev) => [...prev, ...newFiles]);
    };
    // console.log('docList', docList);

    const onRemove = (index) => {
        setDocList((prevFiles) => prevFiles.filter((_, i) => i !== index));
    };

    const onSubmit = async (data) => {
        const groupId = userInfoHeader?.groupId;
        const files = docList.map((item) => ({
            name: item.file.name,
            size: item.file.size,
            type: item.file.type
        }));

        const presignedList = await getPresignedUrls({
            groupId,
            files,
            type: SHARE_KNOWLEDGE_FILE_TYPE.DOCUMENT
        });
        if (!presignedList || presignedList?.length === 0) return;
        const uploadParams = [];
        docList.forEach((doc) => {
            const presigned = presignedList.find(
                (item) => item.name === doc.file.name
            );
            if (presigned) {
                uploadParams.push({
                    file: doc.file,
                    size: doc.file.size,
                    presignedUrl: presigned.url,
                    fields: presigned.fields,
                    name: presigned.name,
                    type: SHARE_KNOWLEDGE_FILE_TYPE.DOCUMENT,
                    code: presigned.code
                });
            }
        });
        await handleUploadFile(uploadParams, async () => {
            const result = uploadParams.map((item) => ({
                name: item.name,
                location: item.fields.key,
                type: SHARE_KNOWLEDGE_FILE_TYPE.DOCUMENT,
                groupId,
                size: item.size,
                code: item.code
            }));
            const res = await createFile({ data: result, type: SHARE_KNOWLEDGE_FILE_TYPE.DOCUMENT, groupId });
            if (res) {
                handleUploadSuccess();
            }
        });
    };

    const handleUploadSuccess = async () => {
        hide();
        props.onUploadSuccess();
    };

    return (
        <div className="share-knowledge-modal-upload-document">
            <div className="modal-body">
                <div className="modal-content">
                    <DragDropFileMulti
                        dragText="ここにファイルをドラッグ＆ドロップまたはファイルを選択する"
                        onChange={onChangeFile}
                        className={'upload-file-zone'}
                        accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.csv,.png,.jpg,.jpeg"
                        description={`対応フォーマット: .PDF, .DOC, .DOCX, .XLS, .XLSX, .PPT, .PPTX, .CSV, .JPG, .PNG。各ファイルの最大容量: ${formatBytes(
                            DOCUMENT_MAX_SIZE
                        )}`}
                        uploadIcon={<div className='mg-b-10'>{IconUploadForm()}</div>}
                    />
                    {docList.length > 0 ? (
                        <>
                            {docList.map((fileData, index) => {
                                return (
                                    <div
                                        className={`file-selected`}
                                        key={index}
                                    >
                                        <div className="flex gap-10 item-center item-box">
                                            <div className="" style={{ width: 24 }}>
                                                {!fileData.isErr ? (
                                                    <img
                                                        src="/images/u248.svg"
                                                        className=""
                                                    />
                                                ) : (
                                                    <img
                                                        src="/images/u258.svg"
                                                        className=""
                                                    />
                                                )}
                                            </div>
                                            <div className="text-14" >
                                                <p className="flex item-center file-name" style={{fontWeight: 700}}>
                                                    <span className="truncate">
                                                        {getFileName(
                                                            fileData.file.name
                                                        )}
                                                    </span>
                                                    <span>
                                                        .
                                                        {getFileExtension(
                                                            fileData.file.name
                                                        )}
                                                    </span>
                                                </p>
                                                <p>
                                                    {!fileData.isErr ? (
                                                        <span className="file-size">
                                                            {formatBytes(
                                                                fileData.file
                                                                    .size
                                                            )}
                                                        </span>
                                                    ) : (
                                                        <span className="text-red-primary text-err">
                                                            ファイルのアップロードに失敗しました。ファイルサイズが上限の{formatBytes(DOCUMENT_MAX_SIZE)}を超えています。
                                                            再度お試しください。
                                                        </span>
                                                    )}
                                                </p>
                                            </div>
                                            <img
                                                src="images/u247.svg"
                                                className="icon-remove"
                                                onClick={() => onRemove(index)}
                                            />
                                        </div>
                                    </div>
                                );
                            })}
                        </>
                    ) : (
                        <></>
                    )}
                </div>
            </div>
            <div className="modal-footer">
                <button type="button" className="cancel" onClick={hide}>
                    キャンセル
                </button>
                <button className="btn btn-submit" onClick={onSubmit} disabled={docList.length === 0 || docList.some((item) => item.isErr)}>
                    保存
                </button>
            </div>
        </div>
    );
};

export default ModalUploadDocument;
